import { render, staticRenderFns } from "./DashboardGDTH.vue?vue&type=template&id=0e9b0454&scoped=true"
import script from "./DashboardGDTH.vue?vue&type=script&lang=js"
export * from "./DashboardGDTH.vue?vue&type=script&lang=js"
import style0 from "./DashboardGDTH.vue?vue&type=style&index=0&id=0e9b0454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9b0454",
  null
  
)

export default component.exports